<template>
  <div
    v-if="allowQuantityPartials(bestPrice)"
    class="product-partials-fi"
  >
    {{ $dict.get('online-Shop.Product.Allow-Partials') }}
  </div>
</template>

<script>
import quantityStepperPartialsMixin from 'mixins/quantityStepperPartialsMixin';

export default {
  name: 'ProductPartialsFi',
  mixins: [quantityStepperPartialsMixin],
  props: {
    bestPrice: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
@import './product-partials-fi';
</style>
